import { Box, Grid, Typography } from '@mui/material';
import { OptionEditor } from '~/src/design/template/option/edit';
import { VariableEditor } from '~/src/design/template/variable/edit';
import { Update } from '~/src/base/Function';
import { Option, Variable } from '~/src/design/template';
import { index } from '~/src/base/Optic';
import { comp } from '~/src/base/Function';
import {
	NewOptType,
	NewVarType,
	TemplateLayoutGroupType,
} from '../helper/types';

import './CornersPanel.css';

interface CornersPanelProps {
	data: TemplateLayoutGroupType;
	updateOpts: Update<Option[]>;
	updateVars: Update<Variable[]>;
}

const isOption = (ps: NewOptType | NewVarType): ps is NewOptType =>
	ps.Type === 'Opts';

const CornersPanel = ({ data, updateOpts, updateVars }: CornersPanelProps) => {
	const { Items } = data;

	const renderCornerInput = (ps: NewVarType | NewOptType) => isOption(ps) ? (
		<OptionEditor
			update={comp(updateOpts, index(ps.ArrIndex))}
			value={ps}
			key={ps.Label}
		/>
	) : (
		<VariableEditor
			update={comp(updateVars, index(ps.ArrIndex))}
			value={ps}
			key={ps.Label}
		/>
	);

	const renderCornerInputs = (cornerIndex: number) => {
		const modeSelect = Items.find((item) => item.Label === `Corner ${cornerIndex}`);
		const clipInput = Items.find((item) => item.Label === `corner${cornerIndex}-clip`);
		const radiusInput = Items.find((item) => item.Label === `corner${cornerIndex}-radius`);

		if (modeSelect) {
			return (
				<Box>
					{renderCornerInput(modeSelect)}
					{clipInput && renderCornerInput(clipInput)}
					{radiusInput && renderCornerInput(radiusInput)}
				</Box>
			);
		}

		return null;
	};

	return (
		<Grid container spacing={1} className="corners-panel">
			<Grid item xs={6} className="corners-panel__corner top-left">
				<Typography variant="caption">Top-Left</Typography>
			</Grid>
			<Grid item xs={6} className="corners-panel__corner top-right">
				<Typography variant="caption">Top-Right</Typography>
			</Grid>
			<Grid item xs={6} className="corners-panel__fields top-left">
				{renderCornerInputs(3)}
			</Grid>
			<Grid item xs={6} className="corners-panel__fields top-right">
				{renderCornerInputs(2)}
			</Grid>
			<Grid item xs={6} className="corners-panel__fields bottom-left">
				{renderCornerInputs(0)}
			</Grid>
			<Grid item xs={6} className="corners-panel__fields bottom-right">
				{renderCornerInputs(1)}
			</Grid>
			<Grid item xs={6} className="corners-panel__corner bottom-left">
				<Typography variant="caption">Bottom-Left</Typography>
			</Grid>
			<Grid item xs={6} className="corners-panel__corner bottom-right">
				<Typography variant="caption">Bottom-Right</Typography>
			</Grid>
		</Grid>
	);
};

export default CornersPanel;
